export const data = [
  {
    id: '11',
    title: 'Food Waste Teacher Guide',
    pdfUrl: 'https://instructional-resources.s3.amazonaws.com/STEMWeekChallenge/K-2_FoodWaste/Documents/FoodWaste_TeacherGuide.pdf',
    subject: 'Food Waste',
    category: '1',
    summary: 'The Teacher Guide provides comprehensive teacher preparation, step-by-step implementation instructions, and extensive teacher resources that can be adapted to fit many different classrooms.'
  },
  {
    id: 12,
    title: 'Food Waste Presentation',
    pdfUrl: 'https://instructional-resources.s3.amazonaws.com/STEMWeekChallenge/K-2_FoodWaste/Documents/FoodWaste_Presentation.pptx',
    subject: 'Food Waste',
    category: '1',
    summary: 'The Presentation contains slides designed to supplement module facilitation.'
  },
  {
    id: 13,
    title: 'Food Waste Additional Teacher Resources',
    pdfUrl: 'https://instructional-resources.s3.amazonaws.com/STEMWeekChallenge/K-2_FoodWaste/Documents/FoodWaste_ProfessionalDevelopmentResources.pdf',
    subject: 'Food Waste',
    category: '1',
    summary: 'Reference this document as needed throughout the implementation process.'
  },
  {
    id: 14,
    title: 'Food Waste Launch Log',
    pdfUrl: 'https://instructional-resources.s3.amazonaws.com/STEMWeekChallenge/K-2_FoodWaste/Documents/FoodWaste_LaunchLog.docx',
    subject: 'Food Waste',
    category: '1',
    summary: 'A Launch Log should be printed for each student. Students will use their Launch Logs throughout the module to record their thinking as they work toward a solution.'
  },
  {
    id: 15,
    title: 'Food Waste Online Teacher Training',
    pdfUrl: 'https://instructional-resources.s3.amazonaws.com/STEMWeekChallenge/K-2_FoodWaste/Documents/FoodWaste_OnlineTeacherTraining.pdf',
    subject: 'Food Waste',
    category: '1',
    summary: 'Resources provided for teachers engaging in online teacher training.'
  },


  {
    id: 21,
    title: 'Energy Waste Teacher Guide',
    pdfUrl: 'https://instructional-resources.s3.amazonaws.com/STEMWeekChallenge/3-5_EnergyWaste/Documents/EnergyWaste_TeacherGuide.pdf',
    subject: 'Energy Waste',
    category: '2',
    summary: 'The Teacher Guide provides comprehensive teacher preparation, step-by-step implementation instructions, and extensive teacher resources that can be adapted to fit many different classrooms.'
  },
  {
    id: 22,
    title: 'Energy Waste Presentation',
    pdfUrl: 'https://instructional-resources.s3.amazonaws.com/STEMWeekChallenge/3-5_EnergyWaste/Documents/EnergyWaste_Presentation.pptx',
    subject: 'Energy Waste',
    category: '2',
    summary: 'The Presentation contains slides designed to supplement module facilitation.'
  },
  {
    id: 23,
    title: 'Energy Waste Additional Teacher Resources',
    pdfUrl: 'https://instructional-resources.s3.amazonaws.com/STEMWeekChallenge/3-5_EnergyWaste/Documents/EnergyWaste_ProfessionalDevelopmentResources.pdf',
    subject: 'Energy Waste',
    category: '2',
    summary: 'Reference this document as needed throughout the implementation process.'
  },
  {
    id: 24,
    title: 'Energy Waste Printables',
    pdfUrl: 'https://instructional-resources.s3.amazonaws.com/STEMWeekChallenge/3-5_EnergyWaste/Documents/EnergyWaste_Printables.pdf',
    subject: 'Energy Waste',
    category: '2',
    summary: 'This resource contains printable items needed to implement the module.'
  },
  {
    id: 25,
    title: 'Energy Waste Launch Log',
    pdfUrl: 'https://instructional-resources.s3.amazonaws.com/STEMWeekChallenge/3-5_EnergyWaste/Documents/EnergyWaste_LaunchLog.docx',
    subject: 'Energy Waste',
    category: '2',
    summary: 'A Launch Log should be printed for each student. Students will use their Launch Logs throughout the module to record their thinking as they work toward a solution.'
  },
  {
    id: 26,
    title: 'Energy Waste Online Teacher Training',
    pdfUrl: 'https://instructional-resources.s3.amazonaws.com/STEMWeekChallenge/3-5_EnergyWaste/Documents/EnergyWaste_OnlineTeacherTraining.pdf',
    subject: 'Energy Waste',
    category: '2',
    summary: 'Resources provided for teachers engaging in online teacher training.'
  },


  {
    id: 31,
    title: 'Plastic Waste Teacher Guide',
    pdfUrl: 'https://instructional-resources.s3.amazonaws.com/STEMWeekChallenge/6-8_PlasticWaste/Documents/PlasticWaste_TeacherGuide.pdf',
    subject: 'Plastic Waste',
    category: '3',
    summary: 'The Teacher Guide provides comprehensive teacher preparation, step-by-step implementation instructions, and extensive teacher resources that can be adapted to fit many different classrooms.'
  },
  {
    id: 32,
    title: 'Plastic Waste Presentation',
    pdfUrl: 'https://instructional-resources.s3.amazonaws.com/STEMWeekChallenge/6-8_PlasticWaste/Documents/PlasticWaste_Presentation.pptx',
    subject: 'Plastic Waste',
    category: '3',
    summary: 'The Presentation contains slides designed to supplement module facilitation.'
  },
  {
    id: 33,
    title: 'Plastic Waste Printables',
    pdfUrl: 'https://instructional-resources.s3.amazonaws.com/STEMWeekChallenge/6-8_PlasticWaste/Documents/PlasticWaste_Printables.pdf',
    subject: 'Plastic Waste',
    category: '3',
    summary: 'This resource contains printable items needed to implement the module.'
  },
  {
    id: 34,
    title: 'Plastic Waste Student Packet',
    pdfUrl: 'https://instructional-resources.s3.amazonaws.com/STEMWeekChallenge/6-8_PlasticWaste/Documents/PlasticWaste_StudentPacket.pdf',
    subject: 'Plastic Waste',
    category: '3',
    summary: 'A Student Packet should be printed for each student. Students will use their packets throughout the module to record their thinking as they work toward a solution.'
  },
  {
    id: 35,
    title: 'Plastic Waste Online Teacher Training',
    pdfUrl: 'https://instructional-resources.s3.amazonaws.com/STEMWeekChallenge/6-8_PlasticWaste/Documents/PlasticWaste_OnlineTeacherTraining.pdf',
    subject: 'Plastic Waste',
    category: '3',
    summary: 'Resources provided for teachers engaging in online teacher training.'
  },


  {
    id: 41,
    title: 'E-Waste Teacher Guide',
    pdfUrl: 'https://instructional-resources.s3.amazonaws.com/STEMWeekChallenge/9-12_E-Waste/Documents/E-Waste_TeacherGuide.pdf',
    subject: 'E-Waste',
    category: '4',
    summary: 'The Teacher Guide provides comprehensive teacher preparation, step-by-step implementation instructions, and extensive teacher resources that can be adapted to fit many different classrooms.'
  },
  {
    id: 42,
    title: 'E-Waste Presentation',
    pdfUrl: 'https://instructional-resources.s3.amazonaws.com/STEMWeekChallenge/9-12_E-Waste/Documents/E-Waste_Presentation.pptx',
    subject: 'E-Waste',
    category: '4',
    summary: 'The Presentation contains slides designed to supplement module facilitation.'
  },
  {
    id: 43,
    title: 'E-Waste Student Packet',
    pdfUrl: 'https://instructional-resources.s3.amazonaws.com/STEMWeekChallenge/9-12_E-Waste/Documents/E-Waste_StudentPacket.pdf',
    subject: 'E-Waste',
    category: '4',
    summary: 'A Student Packet should be printed for each student. Students will use their packets throughout the module to record their thinking as they work toward a solution.'
  },
  {
    id: 44,
    title: 'E-Waste Online Teacher Training',
    pdfUrl: 'https://instructional-resources.s3.amazonaws.com/STEMWeekChallenge/9-12_E-Waste/Documents/E-Waste_OnlineTeacherTraining.pdf',
    subject: 'E-Waste',
    category: '4',
    summary: 'Resources provided for teachers engaging in online teacher training.'
  },


];
